import { CopyProvider } from '@care-platform/shell';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { configFromEnvironment } from './config';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('The page has no #root element.');

createRoot(root).render(
  <StrictMode>
    <CopyProvider>
      <App config={configFromEnvironment()} />
    </CopyProvider>
  </StrictMode>,
);
